import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Agents from './components/Agents';

const agents = (props,{ t }) => (
  <Container>
    <Agents {...props} />
  </Container>
);

agents.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(agents);
